/**
 * ------------------------------------------------------------
 * Custom About Hero
 * IndianVastraa Theme
 * ------------------------------------------------------------
 */

(() => {
    "use strict";

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const heroes = document.querySelectorAll(".about-hero");

    if (!heroes.length) return;

    /*==========================================================
      Intersection Animation
    ==========================================================*/

    if (!reduceMotion && "IntersectionObserver" in window) {

        const observer = new IntersectionObserver((entries) => {

            entries.forEach((entry) => {

                if (entry.isIntersecting) {

                    entry.target.classList.add("is-visible");

                    observer.unobserve(entry.target);

                }

            });

        }, {
            threshold: 0.2
        });

        heroes.forEach((hero) => observer.observe(hero));

    } else {

        heroes.forEach(hero => hero.classList.add("is-visible"));

    }

    /*==========================================================
      Background Zoom
    ==========================================================*/

    heroes.forEach((hero) => {

        if (!hero.classList.contains("enable-parallax")) return;

        const image = hero.querySelector(".about-hero__image");

        if (!image) return;

        window.addEventListener("scroll", () => {

            const rect = hero.getBoundingClientRect();

            const move = rect.top * -0.08;

            image.style.transform = `translateY(${move}px) scale(1.08)`;

        }, {
            passive: true
        });

    });

    /*==========================================================
      Mouse Parallax
    ==========================================================*/

    if (!reduceMotion) {

        heroes.forEach((hero) => {

            const content = hero.querySelector(".about-hero__content");

            if (!content) return;

            let frame;

            hero.addEventListener("mousemove", (e) => {

                cancelAnimationFrame(frame);

                frame = requestAnimationFrame(() => {

                    const rect = hero.getBoundingClientRect();

                    const x = ((e.clientX - rect.left) / rect.width - 0.5) * 12;

                    const y = ((e.clientY - rect.top) / rect.height - 0.5) * 12;

                    content.style.transform = `translate(${x}px, ${y}px)`;

                });

            });

            hero.addEventListener("mouseleave", () => {

                content.style.transform = "translate(0,0)";

            });

        });

    }

    /*==========================================================
      Button Ripple Effect
    ==========================================================*/

    document.querySelectorAll(".about-hero__button").forEach((button) => {

        button.addEventListener("mouseenter", () => {

            button.style.transition = "all .35s ease";

        });

    });

    /*==========================================================
      Image Loaded
    ==========================================================*/

    document.querySelectorAll(".about-hero__image").forEach((img) => {

        if (img.complete) {

            img.classList.add("loaded");

        } else {

            img.addEventListener("load", () => {

                img.classList.add("loaded");

            });

        }

    });

})();